/* eslint-disable no-unused-vars  */
import intersectionObserver from 'intersection-observer';

IntersectionObserver.prototype.POLL_INTERVAL = 100;
